<template>
  <div
    class="bcc-form-item"
    :class="[
      {
        'is-error': validateState === 'error',
        'is-validating': validateState === 'validating',
        'is-success': validateState === 'success',
        'is-required': isRequired || required,
      },
    ]"
  >
    <label
      :for="labelFor"
      class="bcc-form-item__label"
      :style="labelStyle"
      v-if="label || $slots.label || !this.form.inline"
    >
      <span class="bcc-form-item__required-tag">{{
        isRequired ? "*" : ""
      }}</span>
      <slot name="label">{{ label }}</slot>
    </label>
    <div class="bcc-form-item__content" :style="contentStyle">
      <slot></slot>
      <div class="bcc-form-item__error">
        {{ validateMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { safeGet, safeGetDesc } from '../../utils/util'
import Emitter from '../../mixins/emitter'
import AsyncValidator from 'async-validator'
export default {
  name: 'BccFormItem',
  componentName: 'BccFormItem',
  mixins: [Emitter],
  data () {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: ''
    }
  },
  mounted () {
    if (this.prop) {
      this.dispatch('BccForm', 'bcc.form.addField', [this])
      let initialValue = this.fieldValue
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue)
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      })
      this.addValidateEvents()
    }
  },
  beforeDestroy () {
    this.dispatch('BccForm', 'bcc.form.removeField', [this])
  },
  props: {
    prop: String,
    label: String,
    labelWidth: String,
    required: Boolean,
    error: String,
    for: String,
    requiredText: String
  },
  computed: {
    labelFor () {
      return this.for || this.prop
    },
    labelStyle () {
      const ret = {}
      const labelWidth = this.labelWidth || this.form.labelWidth
      if (labelWidth) {
        ret.width = labelWidth
      }
      return ret
    },
    contentStyle () {
      if (this.form.labelPosition === 'top') {
        return {
          marginTop: '10px'
        }
      }
      return {
        marginLeft: '16px'
      }
    },
    form () {
      let parent = this.$parent
      let parentName = parent.$options.name
      while (parentName !== 'BccForm') {
        parent = parent.$parent
        parentName = parent.$options.name
      }
      return parent
    },
    fieldValue () {
      const model = this.form.model
      if (!model || !this.prop) { return }
      let path = this.prop
      return safeGet(model, path, null)
    },
    isRequired () {
      let rules = this.getRules()
      let isRequired = false
      if (rules && rules.length) {
        rules.every(rule => {
          if (rule.required) {
            isRequired = true
            return false
          }
          return true
        })
      }
      return isRequired
    }
  },
  watch: {
    fieldValue () {
      this.onFieldChange()
    },
    error: {
      immediate: true,
      handler (value) {
        this.validateMessage = value
        this.validateState = value ? 'error' : ''
      }
    }
  },
  methods: {
    addValidateEvents () {
      const rules = this.getRules()
      if (rules.length || this.required !== undefined) {
        this.$on('bcc.form.blur', this.onFieldBlur)
        this.$on('bcc.form.change', this.onFieldChange)
      }
    },
    onFieldBlur () {
      this.validate('blur')
    },
    onFieldChange () {
      if (this.validateDisabled) {
        this.validateDisabled = false
        return
      }
      this.validate('change')
    },
    removeValidateEvents () {
      this.$off()
    },
    getRules () {
      let formRules = this.form.rules
      const requiredRule = this.required !== undefined ? { required: !!this.required } : []
      formRules = safeGet(formRules, this.prop || '', [])
      return [].concat(formRules || []).concat(requiredRule)
    },
    getFilteredRule (trigger) {
      const rules = this.getRules()
      return rules.filter(rule => {
        if (!rule.trigger || trigger === '') return true
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1
        } else {
          return rule.trigger === trigger
        }
      }).map(rule => Object.assign({}, rule))
    },
    validate (trigger, callback = () => { }) {
      this.validateDisabled = false
      const rules = this.getFilteredRule(trigger)
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback()
        return true
      }
      this.validateState = 'validating'
      const descriptor = {}
      if (rules && rules.length > 0) {
        rules.forEach(rule => {
          delete rule.trigger
        })
      }
      descriptor[this.prop] = rules
      const validator = new AsyncValidator(descriptor)
      const model = {}
      model[this.prop] = this.fieldValue
      validator.validate(model, { firstFields: true }, (errors, invalidFields) => {
        this.validateState = !errors ? 'success' : 'error'
        let validateMessage = errors ? errors[0].message : ''
        if (validateMessage.indexOf('is required') !== -1) {
          this.validateMessage = this.requiredText || '请填写' + this.label
        } else {
          this.validateMessage = validateMessage
        }
        callback(this.validateMessage, invalidFields)
        this.form && this.form.$emit('validate', this.prop, !errors, this.validateMessage || null)
      }).catch(e => { })
    },
    clearValidate () {
      this.validateState = ''
      this.validateMessage = ''
      this.validateDisabled = false
    },
    resetField () {
      this.validateState = ''
      this.validateMessage = ''
      let model = this.form.model
      let value = this.fieldValue
      let path = this.prop
      let desc = safeGetDesc(model, path)
      this.validateDisabled = true
      if (Array.isArray(value)) {
        desc.o[desc.k] = [].concat(this.initialValue)
      } else {
        desc.o[desc.k] = this.initialValue
      }
      this.$nextTick(() => {
        this.validateDisabled = false
      })
    }
  }
}
</script>
